// extracted by mini-css-extract-plugin
module.exports = {"avatar":"DropdownMenu-module--avatar--35r5J"};